module.exports = __webpack_public_path__ + "img/Button-kosik-2021-01.c939fb08.png";